import React from 'react';
import './_abblock.scss';
import Link from 'gatsby-link';

const ABBlock = ({children, compact, right, card, img, img2x, id, link}) => (
    (link?
    <Link to={link} className={
        'ab-block no-border no-hover plain' + 
        (compact?' compact':'') + 
        (right?' right':' left') + 
        (card?' card':''
    )} id={id}>
        <img className="ab-img" src={img} srcSet={`${img} 300w,${img2x} 1440w`} />
        <aside className="ab-content">
            {children}
        </aside>
    </Link>
    :
    <div className={
        'ab-block' + 
        (compact?' compact':'') + 
        (right?' right':' left') + 
        (card?' card':''
    )} id={id}>
        <img className="ab-img" src={img} srcSet={`${img} 300w,${img2x} 1440w`} />
        <aside className="ab-content">
            {children}
        </aside>
    </div>
    )
)

export default ABBlock


// WEBPACK FOOTER //
// ./src/components/contentblock/abblock/index.jsx